/**
 * @author PoornaChandu
 * @description 
 */
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import NoRecords from '../Utils/NoRecords';
import { Tooltip, Input, Button } from 'antd';
import Highlighter from 'react-highlight-words';
import localStorage from '../../../utils/localStorage';
import StyledTable from "../../../commons/styles/table";
import { API_FILE, IPAddress, REPORTS } from '../../../commons/api';
import { FileExcelOutlined,SearchOutlined } from '@ant-design/icons';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

const TrendTable = (props) => {
  // const [option, setOption] = useState({});
  // const [data, setData] = useState([]);
  // const [language, setLanguage] = useState(props.language || 'English');
  const [reportName, setReportName] = useState('');
  const [dataSource, setDataSource] = useState([]);
  const viewType = props.viewType || 'Single';
  const selectedType= props.selectedType || 'Device';

  const [columns, setColumns] = useState([]);
  const [searchText, setSearchText] = useState('');
  const searchInput = useRef(null);

  useEffect(() => {
    prepareData();
  }, [props.panelData]);

  dayjs.extend(utc);
  dayjs.extend(timezone);

  const getReportNametoDownload = async (excelData, type, viewType, SelectedDate, trendIndex, param) => {
    let { translationCache } = props;
    let Consumption = translation('Trend');
    if (viewType === 'Multiple' && (type === 'timeRange' || type === 'timeWithSelectionType')) {
      Consumption = param ? `${translation(param)}${trendIndex}` : translation('Trend');
    } else if (viewType === 'Multiple') {
      Consumption = param ? translation(param) : translation('Trend');
    }
    let payload = {
      PortName: translation('Rubus'),
      Name: type && type ? translation(type) : translation('Trend'),
      Consumption,
      Data: excelData || [],
      ReportType: 'singleHierarchy',
      GeneratedDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      SelectedDate: dayjs.utc(SelectedDate.From).tz(props.currentTimeZone).format('YYYY-MM-DD HH:mm:ss') +
        '~' +
        dayjs.utc(SelectedDate.To).tz(props.currentTimeZone).format('YYYY-MM-DD HH:mm:ss'),
      SelectionType: 'dateRange',
      IsTranslate: translationCache && translationCache['GeneratedDate'] ? true : false,
      translationList: {
        GeneratedDate: translation('GeneratedDate'),
        SelectedDate: translation('SelectedDate')
      }
    };
    let siteId = localStorage.get('currentSite');
    let accessToken = localStorage.get('accessToken');
    let options = {
      method: 'POST',
      url: `${API_FILE.GenerateExcel}?SiteId=${siteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      data: JSON.stringify(payload)
    };
    return axios(options)
      .then(({ data }) => {
        return data;
      })
      .catch(() => {
        return '';
      });
  };

  const prepareData = async () => {
    const { panelData } = props;
    let dataSource = [];
    let tableData = [];
    if (
      panelData &&
      panelData.trendData &&
      Array.isArray(panelData.trendData) &&
      panelData.trendData.length > 0
    ) {
      let columnsData = panelData.trendData[0] ? Object.keys(panelData.trendData[0]) : [];
      let ImpactColumn = columnsData.includes('Impact');
      columnsData = ImpactColumn ? columnsData.filter((item) => item !== 'Impact') : columnsData;
      let ColourColumn = columnsData.includes('Colour');
      columnsData = ColourColumn ? columnsData.filter((item) => item !== 'Colour') : columnsData;
      const omitKeys = ["ParameterCode", "DeviceCode", "AssetCode"];

      const filteredData = columnsData.filter(
        column => !omitKeys.includes(column)
      );
      let columns = filteredData && Array.isArray(filteredData) && filteredData.map((column) => {
        return {
          title: column,
          dataIndex: column,
          key: column,
          ...getColumnSearchProps(column),
          sorter: (a, b) => a.Value - b.Value
        };
      });
      tableData = panelData.trendData.map((data) => {
        if (
          (panelData &&
            panelData.tunedData &&
            panelData.tunedData.CodeType &&
            panelData.tunedData.CodeType === 'Asset') ||
          selectedType === 'Asset'
        ) {

          return {
            // ...data,
            [translation('DateTime')]: dayjs.utc(data.DateTime, 'YYYY-MM-DD HH:mm:00').tz(props.currentTimeZone).format('YYYY-MM-DD HH:mm:00'),
            [translation('Name')]: `${translation(
              data.ParameterName
            )} (${translation(data.AssetName)})`,
            [translation('Value')]: translation(data.Value),
            [translation('Description')]: `${translation(
              data.Description
            )}`,
            [translation('AssetName')]: translation(data.AssetName),
            [translation('ParameterName')]: translation(data.ParameterName),
            // [translation('ParameterCode')]: translation(data.ParameterCode),
            // [translation('AssetCode')]: translation(data.AssetCode),
            val: translation(data.ParameterName)
          };
        } else {
          return {
            // ...data,
            [translation('DateTime')]: dayjs.utc(data.DateTime, 'YYYY-MM-DD HH:mm:00').tz(props.currentTimeZone).format('YYYY-MM-DD HH:mm:00'),
            [translation('Name')]: `${translation(
              data.ParameterName
            )} (${translation(data.DeviceName)})`,
            [translation('Value')]: translation(data.Value),
            [translation('Description')]: `${translation(
              data.Description
            )}`,
            [translation('DeviceName')]: translation(data.DeviceName),
            [translation('ParameterName')]: translation(data.ParameterName),
            // [translation('ParameterCode')]: translation(data.ParameterCode),
            // [translation('DeviceCode')]: translation(data.DeviceCode),
            val: translation(data.ParameterName)
          };
        }

      });
      dataSource = panelData.trendData.map((data) => {
        delete data.Impact;
        delete data.Colour;
        if (
          (panelData &&
            panelData.tunedData &&
            panelData.tunedData.CodeType &&
            panelData.tunedData.CodeType === 'Asset') ||
          selectedType === 'Asset'
        ) {

          return {
            // ...data,
            DateTime: dayjs.utc(data.DateTime, 'YYYY-MM-DD HH:mm:00').tz(props.currentTimeZone).format('YYYY-MM-DD HH:mm:00'),
            Name: `${translation(data.ParameterName)} (${translation(data.AssetName)})`,
            Value: translation(data.Value),
            Description: `${translation(data.Description)}`,
            AssetName: translation(data.AssetName),
            ParameterName: translation(data.ParameterName),
            // ParameterCode: translation(data.ParameterCode),
            // AssetCode: translation(data.AssetCode)
          };
        } else {
          return {
            // ...data,
            DateTime: dayjs.utc(data.DateTime, 'YYYY-MM-DD HH:mm:00').tz(props.currentTimeZone).format('YYYY-MM-DD HH:mm:00'),
            Name: `${translation(data.ParameterName)} (${translation(data.DeviceName)})`,
            Value: translation(data.Value),
            Description: `${translation(data.Description)}`,
            DeviceName: translation(data.DeviceName),
            ParameterName: translation(data.ParameterName),
            // ParameterCode: translation(data.ParameterCode),
            // DeviceCode: translation(data.DeviceCode)
          };
        }

      });
      if (panelData && panelData.tunedData) {
        let { Type } = panelData;
        let From = dayjs().format('YYYY-MM-DD HH:mm:ss');
        let To = dayjs().format('YYYY-MM-DD HH:mm:ss');
        let { FromDate, ToDate, FromDate1, ToDate1, FromDate2, ToDate2 } = panelData.tunedData;
        if (Type === 'timeRange' && panelData.trendIndex === 0) {
          From = FromDate1;
          To = ToDate1;
        } else if (Type === 'timeRange' && panelData.trendIndex === 1) {
          From = FromDate2;
          To = ToDate2;
        } else {
          From = FromDate;
          To = ToDate;
        }
        let value = tableData[0].val;
        tableData = tableData.map((report) => {
          delete report.val;
          return {
            ...report
          };
        });

        let reportname =  await getReportNametoDownload(
          tableData,
          panelData.Type,
          viewType,
          { From, To },
          panelData.trendIndex,
          value
        );        
        setColumns(columns);
        setDataSource(dataSource);
        setReportName(reportname && reportname.file ? reportname.file : '');
      }
    }
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={'Search'}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text ? text.toString() : ""}
      />
    )
  });

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
        <Tooltip placement="top" title={translation('Download')} style={{width:100}}>
          <a href={`${IPAddress.LOCAL}${REPORTS.Reports}/${reportName}`}>
           <FileExcelOutlined style={{color:'white',fontSize: '30px'}}/>
          </a>
        </Tooltip>
      </div>
      {dataSource && Array.isArray(dataSource) && dataSource.length > 0 ? (
        <StyledTable size="small"
          dataSource={dataSource}
          columns={columns}
          pagination={true}
          bordered={true}
          style={{ padding: '0px 10px', marginTop: '12px' }}
          rowKey={Math.random}
        />
      ) : (
        <NoRecords />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  currentTimeZone: state.LayoutReducer.currentTimeZone
});

export default connect(mapStateToProps)(TrendTable);
